import React from "react";
import { formatValue } from "../utils/Utils.js";

export const TierTooltipContent = ({ tiers }) => {
  if (!tiers || !Array.isArray(tiers)) return null;

  return tiers.map((tier, index) => (
    <div className="flex justify-between" key={"tier-" + index}>
      <div>
        {tier.range} location{tier.range === "Up to 1" ? "" : "s"}
      </div>
      <div>
        {formatValue(tier.price).replace(".00", "")}/location
      </div>
    </div>
  ));
};

